// extracted by mini-css-extract-plugin
export default {"route-container":"RouteTab_route-container__PCv5_"};